var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrackets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5181 6.68241C39.2699 4.40131 39.6855 2.82387 41.8535 1.72742C42.6555 1.3218 43.2401 1.13409 43.6815 2.00003C44.2731 3.16045 44.0367 4.71905 43.8258 5.96081C43.3344 8.85483 43.4138 11.8731 43.0241 14.7964C42.729 17.009 41.9057 24.3122 44.8682 25.2997C46.022 25.6843 48.4458 24.0161 48.2998 22.7019C48.233 22.1013 47.9614 19.4354 46.7443 20.2806C44.6273 21.7507 47.2867 26.0274 48.0432 27.7852C49.6417 31.4995 50.8717 37.2802 50.4646 41.3513C50.2555 43.4423 49.1841 44.9998 47.8668 46.5148C47.0039 47.5072 45.8356 50.5251 43.9381 49.5936C42.0836 48.6832 40.3643 46.0853 40.7149 43.9811C40.9296 42.6931 41.4788 44.3841 40.6829 42.4738",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1385 9.13573C14.4306 7.46509 14.1659 6.07664 12.4445 5.49566C11.4659 5.1654 10.578 4.91296 9.54204 4.8382C7.25133 4.67289 5.29503 6.51515 5.90197 8.84709C6.86344 12.5411 8.59999 15.5614 8.64405 19.5268C8.66921 21.7912 8.69225 24.0817 8.24316 26.3098C7.83308 28.3445 7.65664 31.4248 6.12647 33.0127C5.2476 33.9247 3.63722 35.458 2.2619 34.969C0.964913 34.5079 1.51798 32.7515 2.14965 31.8742C3.38944 30.1522 5.14173 34.2514 5.32469 35.2577C5.92394 38.5536 6.42365 41.9545 6.83203 45.2799C7.1318 47.7208 7.1604 50.3143 8.28325 52.5601C9.0349 54.0633 10.4629 56.8464 12.5166 56.6652C13.6555 56.5647 15.4402 55.5064 15.7719 54.3641C16.2722 52.6407 15.6045 52.4005 14.5612 51.5658",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 1.66333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrackets);
export default __webpack_public_path__ + "static/media/brackets.71295f472bd1e3354a657e2223ce96be.svg";
export { ForwardRef as ReactComponent };